import {LeftOutlined, DeleteOutlined} from '@ant-design/icons';
import {Button, Card, Col, Form, Layout, Row} from 'antd';
import {useParams, useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'

import {Header} from 'pm-components';

import {useGetRecurringExpenseQuery} from '../api';
import * as Inputs from './inputs';
import * as CommonInputs from '../../expenses/details/inputs';
import {useDeleteRecurringExpense, useSaveRecurringExpense} from './hooks';

const {Content} = Layout;

dayjs.extend(weekday)
dayjs.extend(localeData)

export function RecurringExpenseDetails() {
    const {id} = useParams();
    const navigate = useNavigate();

    const isNew = id === 'new';
    const {data: recurringExpense} = useGetRecurringExpenseQuery(id, {skip: isNew});

    const saveRecurringExpense = useSaveRecurringExpense(id!);
    const deleteRecurringExpense = useDeleteRecurringExpense(id!);

    const [form] = Form.useForm();
    const frequency = Form.useWatch('frequency', form);

    if (!isNew && !recurringExpense) {
        return null;
    }

    return (
        <>
            <Header
                leftIcon={<LeftOutlined/>}
                onLeftClick={() => navigate('/auth/recurring-expenses')}
                rightIcon={!isNew && <DeleteOutlined/>}
                onRightClick={deleteRecurringExpense}
                title={isNew ? 'Add' : 'Details'}
            />

            <Content className={'details'}>
                <Form
                    form={form}
                    layout={'vertical'}
                    initialValues={{
                        frequency:     1,
                        frequencyUnit: 'month',
                        ...recurringExpense,
                        startDate: dayjs(recurringExpense?.startDate),
                    }}
                    onFinish={saveRecurringExpense}
                >
                    <Row gutter={[0, 10]}>
                        <Col xs={24}>
                            <Card size={'small'}>
                                <Row gutter={[10, 10]}>
                                    <Col xs={24}><Inputs.Title autoFocus={isNew}/></Col>
                                    <Col xs={12}><CommonInputs.Amount autoFocus={false} form={form}/></Col>
                                    <Col xs={12}><Inputs.Since/></Col>
                                    <Col xs={12}><Inputs.Frequency/></Col>
                                    <Col xs={12}><Inputs.FrequencyUnit frequency={frequency}/></Col>
                                    <Col xs={24}><CommonInputs.Category/></Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Button
                        className={'floating-btn floating-btn--center'}
                        type={'primary'}
                        size={'large'}
                        block={true}
                        htmlType={'submit'}
                    >
                        Save
                    </Button>
                </Form>
            </Content>
        </>
    );
}
